<template>
  <div>
    <template v-if="addFieldType === 'select'">
      <VSelect
        v-model="additionalInput"
        :items="addField.availableValues"
        outlined
        :error-messages="additionalFieldError"
        :menu-props="{ offsetY: true, nudgeBottom: 10, attach: true }"
        @change="changeInputValue"
      >
        <template v-slot:label>
          {{ addFieldLabel }} <span v-if="addFieldRequired" class="red--text">*</span>
        </template>
      </VSelect>
    </template>
    <template v-else-if="addFieldType === 'date' || addFieldType === 'integer'">
      <VTextField
        v-model="additionalInput"
        v-mask="inputMask"
        type="text"
        inputmode="numeric"
        outlined
        dense
        :error-messages="additionalFieldError"
        @input="changeInputValue"
      >
        <template v-slot:label>
          {{ addFieldLabel }} <span v-if="addFieldRequired" class="red--text">*</span>
        </template>
      </VTextField>
    </template>
    <template v-else>
      <VTextField
        v-model="additionalInput"
        type="text"
        outlined
        dense
        :error-messages="additionalFieldError"
        @input="changeInputValue"
      >
        <template v-slot:label>
          {{ addFieldLabel }} <span v-if="addFieldRequired" class="red--text">*</span>
        </template>
      </VTextField>
    </template>
  </div>
</template>

<script>
import {
  ref, toRefs, computed, onMounted,
} from '@vue/composition-api';
import { mask } from 'vue-the-mask';
import { DATE_MASKS } from '../date-utils';

export default {
  name: 'CandidateProfileFormAddInput',
  directives: { mask },
  props: {
    addField: {
      type: Object,
      required: true,
    },
    profileError: {
      type: Object,
      required: true,
    },
    candidateAdditionalValue: {
      required: false,
    },
  },
  setup(props, { emit }) {
    const { addField, profileError, candidateAdditionalValue } = toRefs(props);

    const addFieldType = computed(() => addField.value.type);
    const addFieldLabel = computed(() => addField.value.label);
    const addFieldRequired = computed(() => addField.value.required);
    const addFieldValue = computed(() => addField.value.value);

    const inputMask = computed(() => {
      if (addFieldType.value === 'date') {
        return DATE_MASKS.ru.short;
      }
      if (addFieldType.value === 'integer') {
        return '##########';
      }
      return null;
    });

    const additionalFieldError = computed(() => profileError.value.errors[`additionalFields.${addFieldValue.value}`]);

    const additionalInput = ref(null);

    function changeInputValue(value) {
      emit('setAdditionalValue', value, addFieldValue.value);
    }

    function setCandidateValue() {
      if (!candidateAdditionalValue.value) return;
      additionalInput.value = candidateAdditionalValue.value;
    }

    onMounted(() => {
      setCandidateValue();
    });

    return {
      additionalInput,
      changeInputValue,
      addFieldType,
      addFieldLabel,
      addFieldRequired,
      additionalFieldError,
      inputMask,
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-select {
    .v-input__control {
      .v-input__slot {
        max-height: 40px !important;
        min-height: 40px !important;
        .v-select__slot {
          .v-input__append-inner {
            margin-top: 8px !important;
          }
          .v-label {
            top: auto !important;
          }
        }
      }
    }
  }
  .v-text-field--outlined .v-label--active {
    transform: translateY(-18px) scale(0.75) !important;
  }
  .v-list-item {
    min-height: 40px;
    .v-list-item__content {
      .v-list-item__title {
        font-size: 13px;
        color: #000;
      }
    }
  }
}
</style>
